// import './AboutPage.scss';
// import React, { useEffect } from 'react';
// import ContactUs from '../../Components/Mersa/ContactUs/ContactUs';
// import { Tag } from 'antd';
// import img from '../../assets/images/about.png';
// import imgGet from '../../assets/images/imgGet.png';
// import Aos from 'aos';
// import { Helmet } from 'react-helmet';
// import { useQuery } from '@tanstack/react-query';
// import { getAbout } from '../../Network/home';
// const AboutPage = ({ t }) => {
//   useEffect(() => {
//     Aos.init({
//       duration: 1500,
//     });
//   }, []);
//   const { data: dataAbout, isLoading } = useQuery({
//     queryKey: ['getAbout'],
//     queryFn: () => getAbout(),
//   });
//   return (
//     <div className="about-page">
//       <Helmet>
//         <title>About - Merse</title>
//       </Helmet>
//       <div className="container">
//         <div className="content content-about">
//           <div className="about-info">
//             <h1 className="about-info-title" data-aos="zoom-in">
//               {t.AboutUs}
//             </h1>
//             <p className="about-info-description" data-aos="fade-up">
//               {t.aboutDesc}
//             </p>
//           </div>
//           <div className="card-about" data-aos="zoom-in">
//             <div
//               className="img"
//               style={{
//                 marginBottom: '60px',
//               }}
//             >
//               <img src={img} alt="" />
//             </div>
//             {/* <div className="content-card-about">
//                         <h2>{t.cardAboutTitle}</h2>
//                         <Tag
//                           style={{
//                             backgroundColor: '#3FE6FF',
//                             color: '#000',
//                             padding:"6px 32px 6px 32px",
//                             borderRadius: "40px",
//                             fontSize: "16px",
//                             fontWeight: "600",
//                           }}
//                         >
//                             2024
//                         </Tag>
//                     </div> */}
//           </div>
//           <div className="our-about">
//             <div className="info-our-about">
//               <div className="our-title">
//                 <h1 className="our-title-one">{t.Our}</h1>
//                 <h1 className="our-title-two">{t.MISSION}</h1>
//               </div>
//               <h3 className="our-description"> {t.ourAboutDescOne}</h3>
//             </div>
//             <div className="info-our-about">
//               <div className="our-title">
//                 <h1 className="our-title-one">{t.Our}</h1>
//                 <h1 className="our-title-two">{t.VISION}</h1>
//               </div>
//               <h3 className="our-description"> {t.ourAboutDescTwo}</h3>
//             </div>
//           </div>
//           <div className="about-wil-get">
//             <h2 className="title-about-wil-get">
//               {/* {t.VALUESYOUWILLGET} */}
//               {t.ESSENCEOfMERSE}
//               <img src={imgGet} alt="" />
//             </h2>
//             <div className="content-get">
//               <div className="item-get">
//                 <div className="info-title-get">
//                   <h2 className="title-get"> {t.Authentic} </h2>
//                   {/* <h2 className='title-get'> {t.No}.1 </h2> */}
//                 </div>
//                 <p className="description-get">{t.AuthenticDesc}</p>
//               </div>
//               <div className="item-get">
//                 <div className="info-title-get">
//                   <h2 className="title-get"> {t.Dauntless} </h2>
//                   {/* <h2 className='title-get'> {t.No}.2 </h2> */}
//                 </div>
//                 <p className="description-get">{t.DauntlessDesc}</p>
//               </div>
//               <div className="item-get">
//                 <div className="info-title-get">
//                   <h2 className="title-get"> {t.Mastery} </h2>
//                   {/* <h2 className='title-get'> {t.No}.3 </h2> */}
//                 </div>
//                 <p className="description-get">{t.MasteryDesc}</p>
//               </div>
//               <div className="item-get">
//                 <div className="info-title-get">
//                   <h2 className="title-get"> {t.Agility} </h2>
//                   {/* <h2 className='title-get'> {t.No}.4 </h2> */}
//                 </div>
//                 <p className="description-get">{t.AgilityDesc}</p>
//               </div>
//             </div>
//           </div>
//           <div className="about-message">
//             <h2 className="title-about-message">{t.MessagefromMerseTeam}</h2>
//             <p className="description-about-message">{t.messageDescription}</p>
//           </div>
//         </div>
//         <div className="about-contact">
//           <h1 className="title-about-contact"> {t.RequestaQuotation} </h1>
//           <ContactUs t={t} />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AboutPage;
import './AboutPage.scss';
import React, { useEffect } from 'react';
import ContactUs from '../../Components/Mersa/ContactUs/ContactUs';
import { Tag, Skeleton } from 'antd'; // استيراد Skeleton
import img from '../../assets/images/about.png';
import imgGet from '../../assets/images/imgGet.png';
import Aos from 'aos';
import { Helmet } from 'react-helmet';
import { useQuery } from '@tanstack/react-query';
import { getAbout } from '../../Network/home';

const AboutPage = ({ t }) => {
  useEffect(() => {
    Aos.init({
      duration: 1500,
    });
  }, []);

  const { data: dataAbout, isLoading } = useQuery({
    queryKey: ['getAbout'],
    queryFn: () => getAbout(),
  });

  // عرض شاشة تحميل عند جلب البيانات
  if (isLoading) {
    return (
      <div className="about-page container">
        {/* Skeleton للقسم الرئيسي */}
        <Skeleton active paragraph={{ rows: 4 }} className="skeleton-main" />

        {/* Skeleton لـ Our Mission و Our Vision */}
        <div className="our-about">
          <Skeleton.Input
            style={{ width: 150 }}
            active
            size="large"
            className="skeleton-title"
          />
          <Skeleton active paragraph={{ rows: 2 }} className="skeleton-text" />
          <Skeleton.Input
            style={{ width: 150 }}
            active
            size="large"
            className="skeleton-title"
          />
          <Skeleton active paragraph={{ rows: 2 }} className="skeleton-text" />
        </div>

        {/* Skeleton لـ Essences */}
        <div className="about-wil-get">
          <Skeleton active paragraph={{ rows: 1 }} className="skeleton-title" />
          <div className="content-get">
            <Skeleton
              active
              paragraph={{ rows: 2 }}
              className="skeleton-card"
            />
            <Skeleton
              active
              paragraph={{ rows: 2 }}
              className="skeleton-card"
            />
            <Skeleton
              active
              paragraph={{ rows: 2 }}
              className="skeleton-card"
            />
            <Skeleton
              active
              paragraph={{ rows: 2 }}
              className="skeleton-card"
            />
          </div>
        </div>
      </div>
    );
  }

  const aboutData = dataAbout?.data;
  if (!aboutData) {
    return (
      <div className="about-page container">
        <p>No data found.</p>
      </div>
    );
  }

  return (
    <div className="about-page">
      <Helmet>
        <title>About - Merse</title>
      </Helmet>
      <div className="container">
        <div className="content content-about">
          <div className="about-info">
            <h1 className="about-info-title" data-aos="zoom-in">
              {t.AboutUs}
            </h1>
            <p className="about-info-description" data-aos="fade-up">
              {/* هنا نستخدم البيانات من الـ API */}
              {aboutData?.description}
            </p>
          </div>
          <div className="card-about" data-aos="zoom-in">
            <div
              className="img"
              style={{
                marginBottom: '60px',
              }}
            >
              <img src={aboutData?.image} alt="About Merse" />
            </div>
          </div>
          <div className="our-about">
            <div className="info-our-about">
              <div className="our-title">
                <h1 className="our-title-one">{t.Our}</h1>
                <h1 className="our-title-two">{t.MISSION}</h1>
              </div>
              <h3 className="our-description">{aboutData?.mission}</h3>
            </div>
            <div className="info-our-about">
              <div className="our-title">
                <h1 className="our-title-one">{t.Our}</h1>
                <h1 className="our-title-two">{t.VISION}</h1>
              </div>
              <h3 className="our-description">{aboutData?.vision}</h3>
            </div>
          </div>
          <div className="about-wil-get">
            <h2 className="title-about-wil-get">
              {t.ESSENCEOfMERSE}
              <img src={imgGet} alt="" />
            </h2>
            <div className="content-get">
              {aboutData?.essences && aboutData?.essences?.length > 0 ? (
                aboutData.essences.map((essence, index) => (
                  <div className="item-get" key={index}>
                    <div className="info-title-get">
                      <h2 className="title-get">{essence?.title}</h2>
                    </div>
                    <p className="description-get">{essence?.description}</p>
                  </div>
                ))
              ) : (
                <>
                  <div className="item-get">
                    <div className="info-title-get">
                      <h2 className="title-get"> {t.Authentic} </h2>
                    </div>
                    <p className="description-get">{t.AuthenticDesc}</p>
                  </div>
                  <div className="item-get">
                    <div className="info-title-get">
                      <h2 className="title-get"> {t.Dauntless} </h2>
                    </div>
                    <p className="description-get">{t.DauntlessDesc}</p>
                  </div>
                  <div className="item-get">
                    <div className="info-title-get">
                      <h2 className="title-get"> {t.Mastery} </h2>
                    </div>
                    <p className="description-get">{t.MasteryDesc}</p>
                  </div>
                  <div className="item-get">
                    <div className="info-title-get">
                      <h2 className="title-get"> {t.Agility} </h2>
                    </div>
                    <p className="description-get">{t.AgilityDesc}</p>
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="about-message">
            <h2 className="title-about-message">{t.MessagefromMerseTeam}</h2>
            <p className="description-about-message">{aboutData?.message}</p>
          </div>
        </div>
        <div className="about-contact">
          <h1 className="title-about-contact"> {t.RequestaQuotation} </h1>
          <ContactUs t={t} />
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
